var _path, _rect, _rect2, _rect3, _rect4, _g, _path2, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningError = function SvgWarningError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#warning_error_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_error_svg__b)",
    d: "M135.346 64.156C137.392 50.835 148.854 41 162.332 41h34.839c13.478 0 24.94 9.835 26.986 23.156l34.609 225.259c2.54 16.537-10.255 31.449-26.986 31.449H127.723c-16.731 0-29.526-14.912-26.986-31.449z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213.014,
    height: 38.272,
    x: 73.244,
    y: 301.728,
    fill: "url(#warning_error_svg__c)",
    rx: 19.136
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 47.779,
    height: 7.205,
    x: 155.152,
    y: 41,
    fill: "#D0991B",
    rx: 3.602
  })), /*#__PURE__*/React.createElement("mask", {
    id: "warning_error_svg__f",
    width: 214,
    height: 39,
    x: 73,
    y: 301,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38.272,
    height: 213.014,
    x: 286.258,
    y: 301.728,
    fill: "url(#warning_error_svg__d)",
    rx: 19.136,
    transform: "rotate(90 286.258 301.728)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 213.014,
    height: 38.272,
    x: 73.244,
    y: 301.728,
    fill: "url(#warning_error_svg__e)",
    rx: 19.136
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#warning_error_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_error_svg__g)",
    d: "M73.244 294.552h213.014V340H73.244z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "warning_error_svg__i",
    width: 160,
    height: 280,
    x: 100,
    y: 41,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_error_svg__h)",
    d: "M135.346 64.156C137.392 50.835 148.854 41 162.332 41h34.839c13.478 0 24.94 9.835 26.986 23.156l34.609 225.259c2.54 16.537-10.255 31.449-26.986 31.449H127.723c-16.731 0-29.526-14.912-26.986-31.449z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#warning_error_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.244 117.544h213.014v45.448H73.244z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#warning_error_svg__j)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 284.228,
    cy: 313.102,
    r: 60.041,
    fill: "#C43831"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M284.759 330.593a6.057 6.057 0 0 1-6.057-6.057v-42.401a6.057 6.057 0 0 1 12.115 0v42.401a6.057 6.057 0 0 1-6.058 6.057",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M290.817 345.645a6.057 6.057 0 1 1-12.115 0 6.057 6.057 0 0 1 12.115 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_error_svg__b",
    x1: 245.591,
    x2: 109.616,
    y1: 145.47,
    y2: 294.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADB14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8AD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_error_svg__c",
    x1: 48.507,
    x2: 91.847,
    y1: 323.606,
    y2: 209.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_error_svg__d",
    x1: 309.559,
    x2: 245.775,
    y1: 264.113,
    y2: 275.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#BFB6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B6E61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_error_svg__e",
    x1: 48.507,
    x2: 91.847,
    y1: 323.606,
    y2: 209.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_error_svg__g",
    x1: 202.931,
    x2: 186.992,
    y1: 286.526,
    y2: 361.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#BFB6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B6E61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_error_svg__h",
    x1: 179.751,
    x2: 179.751,
    y1: 41,
    y2: 320.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECB922",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "warning_error_svg__a",
    width: 233.014,
    height: 319,
    x: 63.244,
    y: 39,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2270_1665"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect2_dropShadow_2270_1665"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2270_1665",
    result: "effect2_dropShadow_2270_1665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2270_1665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "warning_error_svg__j",
    width: 132.082,
    height: 132.082,
    x: 218.187,
    y: 251.06,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2270_1665"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect2_dropShadow_2270_1665"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2270_1665",
    result: "effect2_dropShadow_2270_1665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2270_1665",
    result: "shape"
  })))));
};
export { SvgWarningError as ReactComponent };
export default new URL("/codebuild/output/src2904739687/src/src/assets/svgs/warning_error.svg", import.meta.url).toString();